<template>
    <div v-if="visible && noticeText" class="notice-bar">
        <span class="notice-bar__text" v-html="noticeText"></span>
        <button class="notice-bar__close" @click="close" aria-label="닫기">×</button>
    </div>
</template>

<script>
    const SESSION_KEY = 'notice_bar_closed';

    export default {
        name: 'NoticeBar',
        data() {
            return {
                visible: false,
                noticeText: '',
            };
        },
        async mounted() {
            if (sessionStorage.getItem(SESSION_KEY) === 'true') {
                return;
            }
            try {
                const res = await this.call_api('get', 'notice-bar');
                if (res.data.success && res.data.data && res.data.data.text) {
                    this.noticeText = res.data.data.text;
                    this.visible = true;
                }
            } catch (e) {
                // 공지 없을 경우 조용히 무시
            }
        },
        methods: {
            close() {
                this.visible = false;
                sessionStorage.setItem(SESSION_KEY, 'true');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .notice-bar {
        position: relative;
        width: 100%;
        padding: 20px 0;
        color: #ffffff;
        font-size: 18px;
        font-weight: 500;
        background-color: #2196f3;
        text-align: center;
    }

    .notice-bar__text {
        display: inline-block;
    }

    .notice-bar__text :deep(img) {
        max-width: 100%;
        max-height: 60px;
        vertical-align: middle;
        object-fit: contain;
    }

    .notice-bar__text :deep(a) {
        color: #ffffff;
        /* text-decoration: underline; */
        text-underline-offset: 3px;
    }

    .notice-bar__text :deep(a:hover) {
        opacity: 0.85;
        color: #ffffff;
    }

    .notice-bar__close {
        position: absolute;
        /* right: 16px; */
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        color: #ffffff;
        font-size: 22px;
        font-weight: 700;
        cursor: pointer;
        line-height: 1;
        padding: 4px 8px;
        opacity: 0.8;
        transition: opacity 0.15s;
    }

    .notice-bar__close:hover {
        opacity: 1;
    }
</style>
